import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María González',
    role: 'Gerente de Proyectos',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80',
    quote: 'Por fin cierro algo real cada día. Antes terminaba exhausta sin saber qué había logrado. Ahora tengo menos ruido mental porque veo el progreso.'
  }, {
    name: 'Carlos Ruiz',
    role: 'Emprendedor Tech',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80',
    quote: 'El protocolo de retorno cambió mi vida. Me interrumpen igual que antes, pero ya no pierdo el hilo. Vuelvo al bloque y sigo.'
  }, {
    name: 'Ana Martínez',
    role: 'Directora de Marketing',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80',
    quote: 'Implementé el sistema en 2 días. La sensación de cerrar una tarea importante cada día es adictiva. Mi equipo también lo está usando.'
  }];
  return <section className="py-24 bg-dark-800" data-id="element-561">
      <div className="max-w-7xl mx-auto px-4" data-id="element-562">
        <div className="text-center mb-16" data-id="element-563">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-564">
            Historias de{' '}
            <span className="text-gold-500 font-serif italic" data-id="element-565">Cierre</span>
          </h2>
          <p className="text-gray-400" data-id="element-566">
            Profesionales que recuperaron control con el Método CIERRE 90'
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-567">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-dark-900 p-8 rounded-2xl border border-white/5 relative" data-id="element-568">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-gold-500/20" data-id="element-569" />

              <div className="flex gap-1 mb-6" data-id="element-570">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-gold-500 fill-gold-500" data-id="element-571" />)}
              </div>

              <p className="text-gray-300 mb-8 leading-relaxed min-h-[120px]" data-id="element-572">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-573">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border border-gold-500/50" data-id="element-574" />
                <div data-id="element-575">
                  <h4 className="text-white font-bold" data-id="element-576">{testimonial.name}</h4>
                  <p className="text-gold-500 text-sm" data-id="element-577">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}